import { FeatureFlags } from '@datacamp/exercise-feature-flags';
import { createTranslationsInstance, DEFAULT_LANGUAGE } from '@datacamp/exercise-library-translation-utils';
import { ErrorBoundary } from '@datacamp/le-shared-components';
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { createEntityProvider } from './createEntityProvider';
import { ExerciseContract } from './ExerciseContract';
import { Loader } from './Loader';
import { LoggedIn } from './LoggedIn';
import { Spinner } from './Spinner';
import { TrackerProvider } from './TrackerContext';
import { jsx as ___EmotionJSX } from "@emotion/react";
const createExercise = _ref => {
  let {
    config,
    provideUserEventTracker,
    requireAuthenticatedUser,
    sentryInstance,
    setExerciseEntity,
    store,
    translations,
    type,
    validate
  } = _ref;
  return ExerciseComponent => {
    const {
      EntityContext,
      EntityProvider
    } = createEntityProvider({
      setExerciseEntity
    });
    const Exercise = _ref2 => {
      let {
        initialExerciseProps
      } = _ref2;
      return ___EmotionJSX(Provider, {
        store: store
      }, ___EmotionJSX(ExerciseContract, {
        initialExerciseProps: initialExerciseProps,
        type: type
      }, _ref3 => {
        let {
          callbacks,
          exerciseProps
        } = _ref3;
        if (exerciseProps === undefined) {
          return ___EmotionJSX(Spinner, null);
        }
        const {
          environment,
          id,
          nextIds,
          resources,
          user
        } = exerciseProps;
        sentryInstance.configureForExercise(exerciseProps);
        if (id === undefined) {
          return ___EmotionJSX(Spinner, null);
        }
        return ___EmotionJSX(LoggedIn, {
          shouldBeLoggedIn: requireAuthenticatedUser,
          signupFormUrl: config(environment).urls.MAIN_APP,
          user: user
        }, _ref4 => {
          var _user$language;
          let {
            user: definedUser
          } = _ref4;
          const language = (_user$language = user === null || user === void 0 ? void 0 : user.language) !== null && _user$language !== void 0 ? _user$language : DEFAULT_LANGUAGE;
          const i18next = createTranslationsInstance({
            language,
            resources: translations
          });
          const exerciseContent = ___EmotionJSX(EntityProvider, null, ___EmotionJSX(EntityContext.Consumer, null, _ref5 => {
            let {
              getExercise,
              setExercise
            } = _ref5;
            return ___EmotionJSX(Loader, {
              environment: environment,
              exerciseId: id,
              getData: getExercise,
              language: language,
              nextIds: nextIds,
              onError: sentryInstance.captureError,
              setData: setExercise,
              validate: validate
            }, _ref6 => {
              let {
                error,
                exercise
              } = _ref6;
              return error ? ___EmotionJSX(ErrorBoundary, {
                forceToShow: true,
                onErrorReported: sentryInstance.captureError
              }) : ___EmotionJSX(I18nextProvider, {
                i18n: i18next
              }, ___EmotionJSX(FeatureFlags, {
                authorizationKey: config(environment).SPLIT_IO_API_KEY,
                courseId: exercise && exercise.course_id,
                user: definedUser
              }, ___EmotionJSX(ExerciseComponent, {
                callbacks: callbacks,
                environment: environment,
                exercise: exercise,
                id: id,
                resources: resources,
                user: definedUser
              })));
            });
          }));
          return provideUserEventTracker && definedUser.id != null ? ___EmotionJSX(TrackerProvider, {
            userId: definedUser.id
          }, exerciseContent) : exerciseContent;
        });
      }));
    };
    return Exercise;
  };
};
export { createExercise };